import React from 'react'
import Founder from '../AboutSection/Founder'
import About from '../AboutSection/About'
import Education from '../AboutSection/Education'
import School from '../AboutSection/School'
import Follows from '../AboutSection/Follows'
import Testi from '../AboutSection/Testi'
import Aws from '../AboutSection/Aws'

const MyAbout = () => {
  return (
    <div>

<Founder />
    <About/>
    
    <School />
    <Education/>
    <Follows/>
    <Testi/>
    <Aws/>
    </div>
  )
}

export default MyAbout